import axios from 'axios';
import config from "../app.config";
import Cookies from "js-cookie";
import {removeLS, storeLS} from "../utils/localStorage-utils";


export var loginService;
export default loginService = {
    handleLogin,
    loginByToken,
    logout,
    getByUid,
}

async function handleLogin(account) {
    return await axios.post(`${config.LOCAL_API_URL}/login`, account)
        .then(response => {
            if (response.data.success) {
                let data = response.data.data
                let token = data.token.accessToken
                let user = data.user
                let expires_time = data.expires_in
                if (data.hasOwnProperty('rememberLogin') && data.rememberLogin === true &&
                    data.hasOwnProperty('expires_days')) {
                    // console.log('before set cookie')
                    // console.log('data.expires_days')
                    // console.log(data.expires_days)
                    Cookies.set('rememberLogin', token, {expires: data.expires_days})
                }

                window.sessionStorage.setItem('token', token);
                window.localStorage.setItem('expires_time', expires_time);
                storeLS('userInfo', JSON.stringify(user));
                return Promise.resolve(response);
            }
            else{
                return Promise.resolve(response);
            }
        })
        .catch(error =>{
            return Promise.reject(error.response);
        })
}

async function loginByToken(account) {
    return await axios.post(`${config.LOCAL_API_URL}/login-by-token`, account)
        .then(response => {
            if (response.data.success) {
                let data = response.data.data
                let token = data.token.accessToken
                let user = data.user
                let expires_time = data.expires_in
                if (data.hasOwnProperty('rememberLogin') && data.rememberLogin === true &&
                    data.hasOwnProperty('expires_days')
                ) {
                    Cookies.set('rememberLogin', token, {expires: data.expires_days})
                }
                window.sessionStorage.setItem('token', token);
                window.localStorage.setItem('expires_time', expires_time);
                storeLS('userInfo', JSON.stringify(user));

                return Promise.resolve(response);
            } else {
                return Promise.resolve(response);
            }
        })
        .catch(error =>{
            return Promise.reject(error.response);
        })
}

async function logout() {
    return await axios.get(`${config.LOCAL_API_URL}/logout`)
        .then(
            response => {
                // console.log('response logout')
                // console.log(response)
                if (response.data.status) {
                    window.sessionStorage.removeItem('token')
                    removeLS('userInfo')
                    window.localStorage.removeItem('expires_time');
                    // console.log('ok')
                    Cookies.remove('rememberLogin');
                    return Promise.resolve(response.data);
                }
                else{
                    return Promise.resolve(response.data);
                }
        })
        .catch(error =>{
            return Promise.reject(error.response);
        })
}

async function getByUid() {
    return await axios.get(`${config.LOCAL_API_URL}/get-by-uid`)
        .then(
            response => {
                if(response.data.success || response.data.status){
                    return Promise.resolve(response.data);
                }
                else {
                    return Promise.reject(response.data)
                }
            })
        .catch(error =>{
            return Promise.reject(error.response);
        })
}